import * as React from "react";
import styled from "../../styles";
import theme from "../../styles/theme";

type colors = typeof theme.color.typography;

const CompleteStatusSVG = (props: React.SVGProps<SVGSVGElement>) => (
  <svg
    height="15"
    viewBox="0 0 12 13"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <path
      d="M6.02539 12.7461C5.20117 12.7461 4.42773 12.5898 3.70508 12.2773C2.98242 11.9688 2.34766 11.541 1.80078 10.9941C1.25391 10.4473 0.824219 9.8125 0.511719 9.08984C0.203125 8.36719 0.0488281 7.59375 0.0488281 6.76953C0.0488281 5.94531 0.203125 5.17188 0.511719 4.44922C0.824219 3.72656 1.25391 3.0918 1.80078 2.54492C2.34766 1.99414 2.98242 1.56445 3.70508 1.25586C4.42773 0.947266 5.20117 0.792969 6.02539 0.792969C6.84961 0.792969 7.62305 0.947266 8.3457 1.25586C9.06836 1.56445 9.70312 1.99414 10.25 2.54492C10.7969 3.0918 11.2246 3.72656 11.5332 4.44922C11.8457 5.17188 12.002 5.94531 12.002 6.76953C12.002 7.59375 11.8457 8.36719 11.5332 9.08984C11.2246 9.8125 10.7969 10.4473 10.25 10.9941C9.70312 11.541 9.06836 11.9688 8.3457 12.2773C7.62305 12.5898 6.84961 12.7461 6.02539 12.7461ZM6.02539 11.75C6.71289 11.75 7.35742 11.6211 7.95898 11.3633C8.56055 11.1055 9.08984 10.748 9.54688 10.291C10.0039 9.83398 10.3613 9.30469 10.6191 8.70312C10.877 8.10156 11.0059 7.45703 11.0059 6.76953C11.0059 6.08203 10.877 5.4375 10.6191 4.83594C10.3613 4.23047 10.0039 3.70117 9.54688 3.24805C9.08984 2.79102 8.56055 2.43359 7.95898 2.17578C7.35742 1.91797 6.71289 1.78906 6.02539 1.78906C5.33789 1.78906 4.69336 1.91797 4.0918 2.17578C3.49023 2.43359 2.96094 2.79102 2.50391 3.24805C2.04688 3.70117 1.68945 4.23047 1.43164 4.83594C1.17383 5.4375 1.04492 6.08203 1.04492 6.76953C1.04492 7.45703 1.17383 8.10156 1.43164 8.70312C1.68945 9.30469 2.04688 9.83398 2.50391 10.291C2.96094 10.748 3.49023 11.1055 4.0918 11.3633C4.69336 11.6211 5.33789 11.75 6.02539 11.75ZM5.38086 9.54688C5.2832 9.54688 5.19336 9.52539 5.11133 9.48242C5.0332 9.43945 4.95703 9.37109 4.88281 9.27734L3.45312 7.51953C3.36328 7.39844 3.31836 7.27734 3.31836 7.15625C3.31836 7.02734 3.36133 6.91797 3.44727 6.82812C3.53711 6.73438 3.64453 6.6875 3.76953 6.6875C3.85156 6.6875 3.92578 6.70508 3.99219 6.74023C4.0625 6.77148 4.13281 6.83398 4.20312 6.92773L5.35742 8.42188L7.78906 4.51953C7.89844 4.34375 8.03516 4.25586 8.19922 4.25586C8.32031 4.25586 8.42969 4.29492 8.52734 4.37305C8.625 4.45117 8.67383 4.55469 8.67383 4.68359C8.67383 4.75 8.6582 4.81641 8.62695 4.88281C8.59961 4.94531 8.56836 5.00391 8.5332 5.05859L5.85547 9.27734C5.73828 9.45703 5.58008 9.54688 5.38086 9.54688Z"
      fill="#191523"
    />
  </svg>
);

interface Props {
  colorPreset?: keyof colors;
}

export const CompleteStatusIcon = styled(CompleteStatusSVG)<Props>`
  path {
    fill: ${(p) =>
      p.colorPreset
        ? p.theme.color.typography[p.colorPreset]
        : p.color
        ? p.color
        : "#fff"};
  }
`;
